var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_983_22996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.94602 0 0 8.945 0 20C0 31.0538 8.945 40 20 40C31.054 40 40 31.055 40 20C40 8.94617 31.055 0 20 0ZM20 37.2093C10.5108 37.2093 2.7907 29.4893 2.7907 20C2.7907 10.5107 10.5108 2.7907 20 2.7907C29.4892 2.7907 37.2093 10.5107 37.2093 20C37.2093 29.4893 29.4892 37.2093 20 37.2093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 16.6716C18.8156 16.6716 17.9731 17.1719 17.9731 17.9091V27.9392C17.9731 28.5711 18.8156 29.2028 20.0003 29.2028C21.1323 29.2028 22.0536 28.5711 22.0536 27.9392V17.9089C22.0536 17.1719 21.1323 16.6716 20.0003 16.6716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 10.485C18.7895 10.485 17.8418 11.3537 17.8418 12.3541C17.8418 13.3546 18.7895 14.2497 20.0005 14.2497C21.1852 14.2497 22.133 13.3546 22.133 12.3541C22.133 11.3537 21.1851 10.485 20.0005 10.485Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_983_22996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/Info2.87cfae69012e26f241e984a8014fc6f7.svg";
export { ForwardRef as ReactComponent };